module.exports = __webpack_public_path__ + "media/06.6095cc71.mp4";